import customAxios from "../../customAxios";

import { UPDATE_PARENT } from "../../routes";
import { ICreateAndUpdateParent } from "../../../types/parent.interface";

const updateParent = async (formData: ICreateAndUpdateParent) => {
  try {
    return (
      await customAxios.put(UPDATE_PARENT + `/${formData._id}`, {
        city        : formData .city       ,
        area        : formData?.area       ,
        gender      : formData .gender?.value,
        lastName    : formData .lastName   ,
        province    : formData .province   ,
        firstName   : formData .firstName  ,
        kartNumber  : formData?.kartNumber ,
        phoneNumber : formData .phoneNumber,
        shabaNumber : formData?.shabaNumber,
        neighborhood: formData?.neighborhood,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_PARENT: error });
    return false;
  }
};

export default updateParent;
